/* eslint-disable @atlaskit/ui-styling-standard/enforce-style-prop */
import React from 'react';

import { type AvatarIconProps } from './types';

export const AutoReviewAvatar = ({ size, primaryColor, secondaryColor }: AvatarIconProps) => (
	<svg
		width={size}
		height={size}
		viewBox="0 0 42 48"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			d="M19.0069 1.14541C20.241 0.436192 21.759 0.436193 22.9931 1.14541L39.9931 10.9152C41.2346 11.6287 42 12.9514 42 14.3833V33.891C42 35.3229 41.2346 36.6456 39.9931 37.3591L22.9931 47.1289C21.759 47.8381 20.241 47.8381 19.0069 47.1289L2.00691 37.3591C0.765414 36.6456 0 35.3229 0 33.891V14.3833C0 12.9514 0.765415 11.6287 2.00691 10.9152L19.0069 1.14541Z"
			fill={primaryColor}
		/>
		<mask
			id="mask0_7095_38927"
			style={{ maskType: 'alpha' }}
			maskUnits="userSpaceOnUse"
			x="0"
			y="0"
			width="42"
			height="48"
		>
			<path
				d="M19.0069 1.14541C20.241 0.436192 21.759 0.436193 22.9931 1.14541L39.9931 10.9152C41.2346 11.6287 42 12.9514 42 14.3833V33.891C42 35.3229 41.2346 36.6456 39.9931 37.3591L22.9931 47.1289C21.759 47.8381 20.241 47.8381 19.0069 47.1289L2.00691 37.3591C0.765414 36.6456 0 35.3229 0 33.891V14.3833C0 12.9514 0.765415 11.6287 2.00691 10.9152L19.0069 1.14541Z"
				fill={primaryColor}
			/>
		</mask>
		<g mask="url(#mask0_7095_38927)">
			<path
				d="M19.3494 12.0826C19.2594 10.3624 18.8974 8.06745 18.8395 7.24049C19.3044 8.23412 19.1223 5.65708 19.0216 5.23398C18.9788 5.66776 18.786 5.33229 18.8267 5.03741C19.5165 5.45196 19.0473 -1.57829 18.4432 2.03726C18.2868 3.74247 17.9911 7.47769 17.9483 10.1936C18.3082 11.5206 18.9809 17.0956 19.3494 12.0847V12.0826Z"
				fill={secondaryColor}
			/>
			<path
				d="M12.5884 15.0207C12.1557 14.2044 11.6908 13.4971 10.7889 12.6317C10.8638 13.3476 10.4804 12.8561 10.4461 12.5185C11.0888 12.6531 10.2254 11.7236 9.92121 11.5953C10.009 11.7257 9.85265 11.8432 9.70698 11.6445C10.249 11.6017 8.31662 9.32388 8.13239 10.3474C8.38089 10.7064 8.11096 10.8688 8.55656 10.7128C8.07025 11.1274 8.8522 11.121 8.88434 11.1915C8.58441 11.6488 9.50346 11.7193 9.11784 11.8389C9.26566 12.7108 12.6698 16.9311 12.5884 15.0229V15.0207Z"
				fill={secondaryColor}
			/>
			<path
				d="M9.347 22.677C8.35511 21.8864 7.25825 21.3586 5.67937 21.0808C6.33706 21.6877 5.57224 21.4398 5.23804 21.1898C6.71623 20.6492 -1.3667 20.256 1.70108 21.489C1.83819 20.8095 1.74393 21.692 2.1574 21.4419C2.47446 21.2197 2.77652 21.2924 2.77009 21.4676C2.76795 21.6621 3.61845 21.1471 3.38708 21.5146C4.09618 21.6215 10.9794 24.316 9.347 22.677Z"
				fill={secondaryColor}
			/>
			<path
				d="M8.33589 29.6389C7.1919 30.0107 6.13576 30.5983 5.11388 31.7309C5.96009 31.5065 5.33666 32.0236 4.96604 32.139C5.33881 30.5706 0.71358 36.9298 3.35291 35.1328C2.82804 34.6498 3.57141 35.2033 3.55641 34.7438C3.7685 33.763 4.76897 33.8293 5.57448 32.6882C6.03079 31.9381 10.1654 29.8676 8.33589 29.6411V29.6389Z"
				fill={secondaryColor}
			/>
			<path
				d="M16.3074 37.3124C15.2127 30.8463 14.8613 36.1243 15.0627 39.1202C15.474 38.2142 15.4376 39.1757 15.2534 39.5732C14.8527 38.5774 14.7906 41.6139 15.2169 40.9408C15.2212 41.054 15.2576 41.1694 15.2555 41.2763C14.6599 40.8852 15.0241 46.4346 15.8254 43.6033C15.1762 43.4195 16.2388 43.5477 15.594 42.5904C16.3352 41.6502 15.7654 38.8039 16.3074 37.3145V37.3124Z"
				fill={secondaryColor}
			/>
			<path
				d="M27.8716 42.3639C29.0113 40.975 26.0271 31.9682 26.3827 36.8936C26.5156 37.5368 26.6869 38.9685 26.9419 39.9878C27.2375 39.0732 27.3296 39.9942 27.1775 40.3981C26.7084 39.5006 26.869 42.3618 27.2354 41.7122C27.2332 42.1161 26.9226 42.5135 27.0126 43.8298C26.8797 45.4923 27.7238 45.1397 27.7281 44.2722C27.2546 44.1675 28.2058 44.1675 27.6253 43.3084C28.1094 43.2914 27.5417 42.1503 27.8695 42.3639H27.8716Z"
				fill={secondaryColor}
			/>
			<path
				d="M38.3733 32.1839C37.2614 31.8143 36.1752 31.5899 34.6863 31.5707C35.3933 32.0536 34.6071 31.9425 34.29 31.7203C34.9734 31.3677 33.3645 31.2929 33.0282 31.3848C33.251 31.4361 33.1375 31.6198 32.8804 31.5643C33.4267 31.2245 29.774 30.6775 30.3889 31.4532C30.3353 31.6391 30.7467 31.6006 30.8795 31.8378C30.9545 31.8378 30.9566 31.4403 31.053 31.575C30.9352 32.2032 31.67 31.7181 31.7535 31.7502C31.5029 32.3314 40.2799 33.7609 38.3754 32.1882L38.3733 32.1839Z"
				fill={secondaryColor}
			/>
			<path
				d="M39.5772 21.7326C38.3732 21.6279 37.3127 21.6365 35.7724 21.7753C36.6593 22.1878 35.4918 22.2369 35.3868 21.8822C36.1045 21.6899 34.2385 21.6108 34.05 21.7967C34.2899 21.8224 34.185 22.019 33.9193 21.9912C34.1185 21.4911 29.399 21.5083 31.8991 22.5083C31.9762 22.4955 31.9227 22.1066 32.0405 22.2241C32.0062 22.863 32.6896 22.2839 32.7818 22.3074C32.8546 22.8032 33.8422 22.2219 33.6108 22.5638C34.1078 23.1515 41.8758 22.7775 39.575 21.7326H39.5772Z"
				fill={secondaryColor}
			/>
			<path
				d="M30.6759 8.78116C30.5881 7.64649 31.7449 6.85587 31.9613 5.71692C31.5028 3.88137 27.8631 10.9415 29.0563 9.61668C29.4141 9.19572 25.2066 15.4845 26.7105 15.4887C26.7641 15.6041 27.2847 14.8904 27.1861 14.8392C27.0897 14.7451 26.944 14.7237 27.0447 14.6361C27.6253 14.9011 27.4025 13.8669 27.4732 13.7622C28.5807 13.0399 29.2984 10.0996 30.6781 8.77691L30.6759 8.78116Z"
				fill={secondaryColor}
			/>
		</g>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M26.4469 18.9163C22.0894 18.9163 18.6681 22.3025 17.3688 23.9913C18.235 25.6844 22.0894 29.0663 26.4469 29.0663C30.8044 29.0663 34.6588 25.68 35.525 23.9913C34.23 22.2981 30.8044 18.9163 26.4469 18.9163ZM26.4469 20.3163C28.4769 20.3163 30.1219 21.9613 30.1219 23.9913C30.1219 26.0213 28.4769 27.6663 26.4469 27.6663C24.4169 27.6663 22.7719 26.0213 22.7719 23.9913C22.7719 21.9613 24.4169 20.3163 26.4469 20.3163Z"
			fill="#101214"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M26.1931 23.9999L28.8225 27.1981L26.5125 31.2056L22.4218 30.5231L20.9737 34.4037H16.3493L14.8925 30.5231L10.8018 31.2056L8.49622 27.1981L11.1212 23.9999L8.49622 20.8018L10.8018 16.7943L14.8925 17.4724L16.3493 13.5962H20.9737L22.4218 17.4724L26.5125 16.7943L28.8268 20.8018L26.1931 23.9999Z"
			fill="white"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M26.4469 27.6706C24.4169 27.6706 22.7719 26.0213 22.7719 23.9913C22.7719 21.9613 24.4169 20.3163 26.4469 20.3163C27.265 20.3163 28.0219 20.5831 28.6344 21.0381L28.8269 20.8019L27.8032 19.0256C27.3657 18.9556 26.9107 18.9163 26.4469 18.9163C22.0894 18.9163 18.6682 22.2981 17.3732 23.9913C18.235 25.6844 22.0894 29.0663 26.4469 29.0663C26.9063 29.0663 27.3613 29.0269 27.8075 28.9569L28.8225 27.1981L28.6257 26.9575C28.0132 27.4038 27.2607 27.6706 26.4469 27.6706Z"
			fill={primaryColor}
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M26.1931 23.9999L28.6256 26.9574C28.0131 27.4037 27.2606 27.6705 26.4469 27.6705C24.4169 27.6705 22.7719 26.0212 22.7719 23.9912C22.7719 21.9612 24.4169 20.3162 26.4469 20.3162C27.265 20.3162 28.0218 20.583 28.6343 21.038L26.1931 23.9999Z"
			fill="#101214"
		/>
	</svg>
);
